export enum Languages {
  English = 0,
  French = 1,
  PsuedoLanguage = 32453,
}

export default Languages;
